export default class TabsContent {
    constructor() {
        this.sections = document.querySelectorAll('.components-block-tabs-content');

        this.ready();
    }

    ready() {
        this.sections.forEach((section) => {
            let container = section.querySelector('.tabs-container');
            let tabsDiv = container.querySelector('.tabs');
            let itemsDiv = container.querySelector('.items');
            let items = itemsDiv.querySelectorAll(
                '.components-block-tabs-content-item, .components-block-tabs-content-icon-card-list'
            );

            items.forEach((item, key) => {
                if (key === 0) {
                    item.dataset.active = true;
                    item.firstElementChild.dataset.active = true;
                }

                tabsDiv.appendChild(item.firstElementChild);
            });
            tabsDiv.querySelectorAll('[data-tab]').forEach((tab) => {
                tab.addEventListener('click', (e) => {
                    items.forEach((item) => {
                        item.dataset.active = false;
                    });

                    tabsDiv.querySelectorAll('[data-tab]').forEach((tab) => {
                        tab.dataset.active = false;
                    });

                    e.target.closest('[data-tab]').dataset.active = true;

                    items.forEach((item) => {
                        if (item.dataset.tab === e.target.closest('[data-tab]').dataset.tab) {
                            item.dataset.active = true;
                        }
                    });
                });
            });
        });
    }
}

if (document.querySelector('.components-block-tabs-content')) {
    new TabsContent();
}
